import type { DataSource, SourceMessage } from './types';

/** Simulated market + real learning agents, running in a Web Worker. */
export class DemoSource implements DataSource {
  readonly kind = 'demo' as const;
  private worker: Worker | null = null;

  constructor(
    private readonly seed: number,
    private readonly warmupDays: number,
    private speed: number,
  ) {}

  start(emit: (msg: SourceMessage) => void): void {
    this.worker = new Worker(new URL('./sim.worker.ts', import.meta.url), { type: 'module' });
    this.worker.onmessage = (e: MessageEvent<SourceMessage>) => emit(e.data);
    this.worker.onerror = () => emit({ type: 'status', status: 'error' });
    this.worker.postMessage({ type: 'start', seed: this.seed, warmupDays: this.warmupDays, speed: this.speed });
  }

  setSpeed(speed: number): void {
    this.speed = speed;
    this.worker?.postMessage({ type: 'speed', speed });
  }

  stop(): void {
    this.worker?.postMessage({ type: 'stop' });
    this.worker?.terminate();
    this.worker = null;
  }
}
